import React, { useState, useEffect } from 'react';
import ClubCard from '../clubCard/clubCard';
import styles from './clubsPage.module.css';
import fetchTeamsShort from '../../api/fetchTeamsShort';
import Header from "../header/header";

interface TeamShort {
	team_id: number;
	team_club_id: number;
	team_club_short_name: string;
	team_club_logo: string;
	team_club_city: string;
	team_club_country: string;
}

const ClubsPage: React.FC = () => {
	const [clubs, setClubs] = useState<TeamShort[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const getTeamsShort = async () => {
			try {
				const data = await fetchTeamsShort();
				setClubs(data);
			} catch (error) {
				console.error('Error fetching short team data:', error);
			} finally {
				setLoading(false);
			}
		};

		getTeamsShort(); // Call the fetch function
	}, []); // Empty dependency array ensures this runs only once on mount

	return (
		<>
		<Header title={'Clubs'}/>
			<main>
				{loading ? (
					<p>Loading...</p>
				) : (
					<ul className={styles.clubs_list}>
						{clubs.map((club) => (
							<ClubCard key={club.team_id} club={club} />
						))}
					</ul>
				)}
			</main>
		</>
	);
};

export default ClubsPage;
